import { render, staticRenderFns } from "./WarningIcon.vue?vue&type=template&id=352c491c&scoped=true&"
import script from "./WarningIcon.vue?vue&type=script&lang=js&"
export * from "./WarningIcon.vue?vue&type=script&lang=js&"
import style0 from "./WarningIcon.vue?vue&type=style&index=0&id=352c491c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352c491c",
  null
  
)

export default component.exports